import { render, staticRenderFns } from "./FighterCategoryCreate.vue?vue&type=template&id=1e697192&lang=pug"
import script from "./FighterCategoryCreate.vue?vue&type=script&lang=js"
export * from "./FighterCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports